// extracted by mini-css-extract-plugin
export default {"buttonOnly":"button_buttonOnly__znxxP"};